import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';

import { Window } from 'types';

export const getWindow = async (windowId: number): Promise<Window> => {
  const { data } = await axios.get(`/api/windows/${windowId}`);
  return data as Window;
};

type QueryFnType = typeof getWindow;

type UseSnapshotsOptions = {
  windowId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useWindow = ({ windowId, config }: UseSnapshotsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['window', windowId],
    queryFn: () => getWindow(windowId),
    ...config,
  });
};
